export const STATIC_DATE_TIME_FORMAT = 'YYYY.MM.DD-HH:mm';
export const STATIC_DATE_FORMAT = 'YYYY.MM.DD';

export type TStaticDateTimeFormat = string; // type for STATIC_DATE_TIME_FORMAT values
export type TStaticDateFormat = string; // type for STATIC_DATE_FORMAT values
